module.exports = __webpack_public_path__ + "img/slider-actors-caption-en.3f81b8a1.png";